module.exports = "//public.zight.com/packs/media/images/annotate/emoji@3x-f641676fb95349d114f691cc3fae1ded.png";